export const ADDITIONAL_FIELD_COUNTRIES = [
  'AU',
  'AT',
  'AL',
  'DZ',
  'AD',
  'AO',
  'BH',
  'BD',
  'BE',
  'BA',
  'BN',
  'BF',
  'BI',
  'BT',
  'GB',
  'IS',
  'GY',
  'GM',
  'GH',
  'GN',
  'GW',
  'DE',
  'GR',
  'DK',
  'IN',
  'ID',
  'JO',
  'IE',
  'IT',
  'KH',
  'CM',
  'QA',
  'CY',
  'KI',
  'KW',
  'LA',
  'LS',
  'LR',
  'LB',
  'LI',
  'LU',
  'MR',
  'MG',
  'MK',
  'MW',
  'MT',
  'MA',
  'FM',
  'MZ',
  'MC',
  'NR',
  'NE',
  'NG',
  'NL',
  'NZ',
  'NO',
  'JE',
  'GG',
  'AE',
  'OM',
  'PW',
  'PG',
  'RW',
  'RO',
  'SA',
  'SZ',
  'SC',
  'SN',
  'RS',
  'SG',
  'SI',
  'SB',
  'SR',
  'TJ',
  'TH',
  'TW',
  'TG',
  'TO',
  'TV',
  'TN',
  'PH',
  'FR',
  'HR',
  'ME',
  'CZ',
  'CH',
  'SE',
  'LK',
  'ZA',
  'JP',
]
